import React, { useState, useEffect } from "react";
import Login from "../../Components/Login/Login";
import DefaultLayout from "../../Layouts/DefaultLayout/DefaultLayout";
import Announce from "../registrationTopNav";
import News from "../../Components/News";
import "./press-relese.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Header from "../../Components/header";
import agcN from "../../Assets/Svg/agcN.svg";
import CustomPagination from "../../Components/CustomPagination/CustomPagination";
import { useTranslation } from "react-i18next";
import { getAllPressList } from "../../Store/Reducer/getAllPressRelease";
import { useDispatch, useSelector } from "react-redux";

const PressRelease = () => {
  const token = localStorage.getItem("vms_vendor_token");
  const { PressList, loading } = useSelector(
    (state) => state.getAllPressRelease
  );
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [enableSee, setEnableSee] = useState(true);
  const itemsPerPage = enableSee ? 6 : PressList?.length;
  const [searchValue, setSearchValue] = useState("");
  const [filteredNews, setFilteredNews] = useState([]);
  const { t } = useTranslation();
  const releasedItems =
    Array.isArray(PressList) &&
    PressList?.filter((item) => item?.press_status === "Released");

  
  const handleBack = () => {
    setEnableSee(!enableSee);
    setCurrentPage(1);
  };
  const handleSearchChange = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setSearchValue(searchTerm);

    const filteredArticles = releasedItems.filter((article) =>
      article.title.toLowerCase().includes(searchTerm)
    );

    setFilteredNews(filteredArticles);

    // Reset currentPage to 1 when searching
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  let displayedNews = releasedItems;

  if (searchValue) {
    displayedNews = filteredNews;
  }

  displayedNews = displayedNews.slice(startIndex, endIndex);

  // Calculate the total number of entries and the current range being displayed
  const totalEntries = filteredNews.length>0?filteredNews.length:releasedItems.length;
  const startEntry = startIndex + 1;
  const endEntry = Math.min(startIndex + itemsPerPage, totalEntries);

  useEffect(() => {
    dispatch(getAllPressList());
  }, []);

  return (
    <>
      {!token ? (
        <div>
          <DefaultLayout>
            <div className="loginpage">
              <Login />
            </div>
          </DefaultLayout>
        </div>
      ) : (
        <div>
          <div className="resetcontentpage">
            <Header />
          </div>
        </div>
      )}

      <div className="">
        <div className="announce-navbar">
          <Announce />
        </div>
        <div className="announcement-page-background ">
          <div className="announcement-jobs-top">
            <h1 className="announcement-jobs-top-header py-2">{t("News")}</h1>

            <input
              type="search"
              placeholder="Search News"
              className="announcement-jobs-top-search py-2 px-3"
              value={searchValue}
              onChange={handleSearchChange}
            />
          </div>
        </div>
      </div>
      {displayedNews?.length > 0 ? (
        <>
          <div className="container mt-5">
            <div className="row">
              <div className="col-12">
                <div className="announcement-news-top">
                  <div>
                    <h1 className="announcement-news-update">
                      {t("Update News")}
                    </h1>
                  </div>
                  <div onClick={handleBack} style={{ cursor: "pointer" }}>
                    {enableSee ? (
                      <h1 className="announcement-news-seeall">
                        See All
                        <span>
                          <ArrowForwardIcon />
                        </span>
                      </h1>
                    ) : (
                      <h1 className="announcement-news-seeall">
                        Back
                        <span>
                          <ArrowBackIcon />
                        </span>
                      </h1>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="news-page-body">
            <div className="container">
              <div className="row">
                {displayedNews?.map((article, index) => (
                  <div className="col-12" key={index}>
                    <News {...article} />
                  </div>
                ))}
                {enableSee && displayedNews?.length >= 1 && (
                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ width: "90%" }}
                  >
                    {" "}
                    <p className="press-entries col-5">
                      Showing {startEntry} to {endEntry} of {totalEntries}{" "}
                      entries
                    </p>
                    <div className="">
                      <CustomPagination
                        totalItems={totalEntries}
                        itemsPerPage={itemsPerPage}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <h1 className="d-flex justify-content-center align-items-center py-5">
          No News Available
        </h1>
      )}
    </>
  );
};

export default PressRelease;
